{
  "title": "Beast Sense",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level divination (ritual)",
  "level": 2,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "S",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You touch a willing beast. For the duration of the spell, you can use your action to see through the beast’s eyes and hear what it hears, and continue to do so until you use your action to return to your normal senses."
  ],
  "spellLists": ["druid", "ranger"]
}
